import * as React from "react";
type Props = {
  className?: string,
};
function SvgTreenutfree({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Tree nut free"
      className={className}
    >
      <path
        d="M26.0935 12.9771L31.5721 6.41139M8.68139 33.8443L13.455 28.1243M18.685 11.8857C20.9864 17.1857 26.8843 24.6135 31.1385 23.6028M18.685 11.8857C20.8407 9.18711 36.615 16.2385 31.1793 23.5535C25.5428 31.6528 16.0978 15.1257 18.685 11.8857ZM31.2714 23.3821C31.3921 18.2814 22.0814 12.6671 18.7621 11.8M18.1021 22.5543L20.3921 19.81M7.99925 20.3657C8.62425 24.6864 11.9821 28.5293 16.2885 28.93C18.4264 29.1285 20.5907 28.29 20.7264 25.8635C20.8471 23.7107 18.36 22.7614 16.6921 21.7593C15.1978 20.86 14.7464 19.2778 15.0678 17.3085C15.345 15.6185 16.405 14.0035 14.2164 12.4614C9.70211 10.4693 7.55211 17.2714 7.99925 20.3657ZM2.14282 20.1278C2.14282 10.195 10.1943 2.14282 20.1264 2.14282C24.8164 2.14282 29.0864 3.93782 32.2878 6.87782C35.8678 10.165 38.1114 14.8843 38.1114 20.1278C38.1114 30.06 30.06 38.1121 20.1264 38.1121C10.1943 38.1121 2.14282 30.06 2.14282 20.1278Z"
        stroke="currentColor"
      />
    </svg>
  );
}
export default SvgTreenutfree;
